module.exports = __webpack_public_path__ + "img/eatDoradoLogo.6d585713.png";